import React from 'react'
import { List } from '@mui/material';
import Item from '../Item/Item'
import './ListItems.css'
function ListItems({tests, removeTest}) {
  return (
    
    <List className='package-name'>
      {
        tests.map((test,index) => {
            return (
              <Item
              key={index} 
              className='package-name-child'
              id={test.value}
              test={test.name}
              removeTest={removeTest}
              />
            );
        })
      }
    </List>
  
  )
}

export default ListItems